import { render } from "./konfirmasiDokter.vue?vue&type=template&id=cd412ac8&scoped=true"
import script from "./konfirmasiDokter.vue?vue&type=script&lang=js"
export * from "./konfirmasiDokter.vue?vue&type=script&lang=js"

import "./konfirmasiDokter.vue?vue&type=style&index=0&id=cd412ac8&scoped=true&lang=css"

import exportComponent from "/Users/mymac/Documents/Digitala/Pulih_Anita/frontend-pulih/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd412ac8"]])

export default __exports__